import {
	AfterViewInit,
	Component,
	ElementRef,
	Input,
	ViewChild,
} from '@angular/core';
import { Coords } from 'src/app/data/utils/geolocation.utils';
declare var google: any;

@Component({
	selector: 'cmv-google-map',
	templateUrl: './google-map.component.html',
	styleUrls: ['./google-map.component.scss'],
})
export class GoogleMapComponent implements AfterViewInit {
	@ViewChild('mapRef') mapRef: ElementRef<HTMLElement>;
	@Input() set markerCoords(coords: Coords) {
		this.coords = coords;
		if (this.coords && this.map) {
			this.addMarker();
		}
	}
	@Input() width = '100%';
	@Input() height = '350px';
	coords: Coords;
	map: any;
	marker: any;

	constructor() {}

	async ngAfterViewInit(): Promise<void> {
		await this.initMap();
		if (this.coords) {
			this.addMarker();
		}
	}
	async initMap(): Promise<void> {
		const { Map } = await google.maps.importLibrary('maps');
		this.map = new Map(document.getElementById('map') as HTMLElement, {
			zoom: 16,
			mapId: 'DEMO_MAP_ID',
		});
	}

	async addMarker(): Promise<void> {
		const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
		this.map.setCenter({
			lat: this.coords.latitude,
			lng: this.coords.longitude,
		});
		this.marker = new AdvancedMarkerElement({
			map: this.map,
			position: { lat: this.coords.latitude, lng: this.coords.longitude },
		});
	}
}
